import { difference } from 'lodash';

import useLocalStorage from '../useLocalStorage';

const CACHE_KEY = 'equip.messages.hasReplies';

interface MessageStatusCacheState {
  addToCache: (messageId: number) => void;
  isInCache: (messageId: number) => boolean;
  removeFromCache: (messageId: number) => void;
  removeBulkFromCache: (messageIds: number[]) => void;
}

const useMessageStatusCache = (): MessageStatusCacheState => {
  const { storedValue: cache, setValue } = useLocalStorage<number[]>(
    CACHE_KEY,
    [],
  );

  const isInCache = (messageId: number): boolean => {
    return cache.includes(messageId ?? 0);
  };

  const addToCache = (messageId: number) => {
    if (!isInCache(messageId)) {
      setValue([...cache, messageId]);
    }
  };

  const removeFromCache = (messageId: number) => {
    setValue(cache.filter((item) => item !== messageId));
  };

  const removeBulkFromCache = (messageIds: number[]) => {
    setValue(difference<number>(cache, messageIds ?? []));
  };

  return { addToCache, isInCache, removeBulkFromCache, removeFromCache };
};

export default useMessageStatusCache;
